import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook } from "@fortawesome/free-solid-svg-icons";
//Components
import TranslationText from "../../atoms/TranslationText";
//Types
import { ProjectItemProps } from "./types";
//Styles
import "./styles.scss";

function ProjectItem({
  description,
  repoUrl,
  siteUrl,
  thumbnail,
  title,
}: ProjectItemProps) {
  return (
    <div className="project-item">
      <div className="project-item__thumbnail-container">
        <img
          className="project-item__thumbnail"
          src={thumbnail}
          alt="project-thumbnail"
        />
      </div>
      <div className="project-item__data-container">
        <a
          aria-label="project-link"
          className="project-item__title"
          href={siteUrl}
          target="_blank"
          rel="noreferrer"
        >
          {title}
        </a>
        <TranslationText
          styles="project-item__description"
          jsonKeysPath={description}
        />
        {repoUrl && (
          <a
            aria-label="project-repo"
            className="project-item__repo-anchor"
            href={repoUrl}
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon
              className="project-item__repo-icon"
              icon={faBook}
            />
            Repo
          </a>
        )}
      </div>
    </div>
  );
}

export default ProjectItem;
